const onlyPositiveNumber = number => {
  const n = Number(number)
  return n >= 0 ? n : 0
}

export default onlyPositiveNumber